import { render, staticRenderFns } from "./InsSlideMenu.vue?vue&type=template&id=0c8bdc5c&scoped=true"
import script from "./InsSlideMenu.vue?vue&type=script&lang=ts"
export * from "./InsSlideMenu.vue?vue&type=script&lang=ts"
import style0 from "./InsSlideMenu.vue?vue&type=style&index=0&id=0c8bdc5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8bdc5c",
  null
  
)

export default component.exports